// Permisos del usuario: deny-by-default. Solo cuenta lo que el backend envía en user.permissions.
export const PERM_ACCESS_CODES_READ = 'properties.access_codes.read';

export function hasPermission(
  user: { permissions?: readonly string[] | null } | null | undefined,
  permission: string
): boolean {
  return Array.isArray(user?.permissions) && user!.permissions!.includes(permission);
}

// Staff de plataforma: solo user.is_platform_staff === true (flag de /me, tabla platform_staff).
// Ser admin de cuenta NO lo implica. El backend valida igual; esto solo decide qué se muestra.
export function isPlatformStaff(user: { is_platform_staff?: boolean | null } | null | undefined): boolean {
  return user?.is_platform_staff === true;
}

// Staff ya verificado O staff con el 2FA pendiente. /me solo publica is_platform_staff=true con X-MFA-Token vigente
// (is_platform_admin); sin el, el staff llega con is_platform_staff=false y platform_staff_pending_mfa=true. Sirve para
// MOSTRAR la entrada y el PlatformMfaGate (que pide el codigo); la autorizacion sigue en el backend.
export function isPlatformStaffOrPending(
  user: { is_platform_staff?: boolean | null; platform_staff_pending_mfa?: boolean | null } | null | undefined
): boolean {
  return user?.is_platform_staff === true || user?.platform_staff_pending_mfa === true;
}
